import Vue from 'vue';
import VueRouter from 'vue-router';
import Info from './../pages/Survey/Info';
import HspInstanceLayout from './../pages/HspCommon/HspInstanceLayout';
import HspUserAdminLayout from './../pages/HspCommon/HspUserAdminLayout';
import HspRoleAdminLayout from './../pages/HspCommon/HspRoleAdminLayout';
import HspLinksAdminLayout from './../pages/HspCommon/HspLinksAdminLayout';
import HspSurveyUsersAdminLayout from './../pages/HspCommon/HspSurveyUsersAdminLayout';
import HspDefaultLayout from './../pages/HspCommon/HspDefaultLayout';
import AuthLayout from './../pages/HspCommon/AuthLayout';
import Surveys from './../pages/Admin/Surveys';
import Instances from './../pages/Admin/Instances';
import Instance from './../pages/Admin/Instance';
import InstanceSummary from './../pages/Admin/Summary';
import InstanceAccess from './../pages/Admin/Access';
import InstanceReports from './../pages/Admin/Reports';
import InstanceDashboard from './../pages/Admin/Dashboard';
import InstanceReportFiles from './../pages/Admin/ReportFiles';
import SurveyAccess from './../pages/Survey/SurveyAccess';
import UserSurvey from './../pages/Survey/Survey';
import SurveyReview from './../pages/Survey/SurveyReview';
import SurveyAuth from './../pages/Survey/SurveyAuth';
import SurveyLogin from './../pages/Survey/SurveyLogin';
import AdminLogin from './../pages/Admin/AdminLogin';
import ForgotPassword from './../pages/Admin/ForgotPassword';
import ResetPassword from './../pages/Admin/ResetPassword';
import EmailAdd from './../pages/Admin/EmailAdd';
import ChangePassword from './../pages/Admin/ChangePassword';
import UserAdmin from './../pages/Admin/UserAdmin';
import User from './../pages/Admin/User';
import RoleAdmin from './../pages/Admin/RoleAdmin';
import Role from './../pages/Admin/Role';
import SurveyUserAdmin from './../pages/Admin/SurveyUserAdmin';
import SurveyUser from './../pages/Admin/SurveyUser';
import LinksAdmin from './../pages/Admin/LinksAdmin';
import ReportFilesAdmin from './../pages/Admin/ReportFilesAdmin';
import Link from './../pages/Admin/Link';
import { isAuthorized } from './../modules/adminActions';
import store from '../store';
import { isNullOrEmpty } from '../modules/utils';

Vue.use(VueRouter);

const allRoles = !isNullOrEmpty(process.env.VUE_APP_ALL_USER_ROLES) ? process.env.VUE_APP_ALL_USER_ROLES : ['analyst','manager','user'];
const surveysRoute = {
  path: '/surveys',
  component: HspDefaultLayout,
  redirect: '/welcome',
  props: {
    showNavbar: false
  },
  children: [
    {
      name: 'SurveyAccess',
      path: 'access/:hspSurveyId',
      component: SurveyAccess
    },
    {
      name: 'ReviewSurvey',
      path: 'access/:hspSurveyId/:surveyId/review',
      component: SurveyReview,
      children: [
        {
          name: 'ReviewSurveySection',
          path: ':sectionId',
          component: SurveyReview,
          beforeEnter: (to, from, next) => {
            if(from.name && from.name.substr(0, 10) === 'Authorized') {
              next(false);
            }
            else {
              next();
            }
          }
        }
      ]
    },
    {
      name: 'ActiveSurvey',
      path: ':surveyId',
      component: UserSurvey,
      children: [
        {
          name: 'ActiveSurveySection',
          path: 's/:sectionId',
          component: UserSurvey,
          beforeEnter: (to, from, next) => {
            if(from.name && from.name.substr(0, 10) === 'Authorized') {
              next(false);
            }
            else {
              next();
            }
          }
        }
      ]
    },
    {
      name: 'Login',
      path: ':surveyId/login',
      component: SurveyLogin
    },
    {
      name: 'AuthorizedSurvey',
      path: ':surveyId/auth',
      component: SurveyAuth,
      children: [
        {
          name: 'AuthorizedSurveySection',
          path: 's/:sectionId',
          component: SurveyAuth
        }
      ]
    }
  ]
}

const adminSurveysRoute = {
  path: '/admin/surveys',
  component: HspDefaultLayout,
  meta: { role: allRoles },
  children: [
    {
      name: 'Surveys',
      path: '/',
      component: Surveys
    }
  ]
}

const adminUserRoute = {
  path: '/admin/users',
  component: HspUserAdminLayout,
  meta: { role: ['administrator','analyst'] },
  redirect: { name: 'Users' },
  children: [
    {
      name: 'Users',
      path: 'administrative',
      component: UserAdmin
    },
    {
      name: 'AddUser',
      path: 'add',
      component: User
    }
  ]
}

const adminRoleRoute = {
  path: '/admin/roles',
  component: HspRoleAdminLayout,
  meta: { role: 'administrator' },
  redirect: { name: 'Roles' },
  children: [
    {
      name: 'Roles',
      path: 'administrative',
      component: RoleAdmin
    },
    {
      name: 'AddRole',
      path: 'add',
      component: Role
    }
  ]
}

const adminSurveyUsersRoute = {
  path: '/admin/surveyusers',
  component: HspSurveyUsersAdminLayout,
  meta: { role: ['administrator','analyst'] },
  redirect: { name: 'SurveyUsers' },
  children: [
    {
      name: 'SurveyUsers',
      path: 'administrative',
      component: SurveyUserAdmin
    },
    {
      name: 'AddSurveyUser',
      path: 'add',
      component: SurveyUser
    }
  ]
}

const adminHspSurveyUsersRoute = {
  path: '/admin/surveyusers/administrative/:surveyId',
  component: HspSurveyUsersAdminLayout,
  meta: { role: ['administrator','analyst'] },
  redirect: { name: 'HspSurveyUsers' },
  children: [
    {
      name: 'HspSurveyUsers',
      path: '/admin/surveyusers/administrative/:surveyId',
      component: SurveyUserAdmin
    },
    {
      name: 'AddHspSurveyUser',
      path: 'add',
      component: SurveyUser
    }
  ]
}

const adminInstanceSurveyUsersRoute = {
  path: '/admin/surveyusers/administrative/:surveyId/:surveyUrlId',
  component: HspSurveyUsersAdminLayout,
  meta: { role: ['administrator','analyst'] },
  redirect: { name: 'InstanceSurveyUsers' },
  children: [
    {
      name: 'InstanceSurveyUsers',
      path: '/admin/surveyusers/administrative/:surveyId/:surveyUrlId',
      component: SurveyUserAdmin
    },
    {
      name: 'AddInstanceSurveyUser',
      path: 'add',
      component: SurveyUser
    }
  ]
}

const adminLinksRoute = {
  path: '/admin/links',
  component: HspLinksAdminLayout,
  meta: { role: ['administrator','analyst'] },
  redirect: { name: 'Links' },
  children: [
    {
      name: 'Links',
      path: 'administrative',
      component: LinksAdmin
    },
    {
      name: 'AddLink',
      path: 'add',
      component: Link
    }
  ]
}

const adminHspSurveyLinksRoute = {
  path: '/admin/links/administrative/:surveyId',
  component: HspLinksAdminLayout,
  meta: { role: ['administrator','analyst'] },
  redirect: { name: 'HspSurveyLinks' },
  children: [
    {
      name: 'HspSurveyLinks',
      path: '/admin/links/administrative/:surveyId',
      component: LinksAdmin
    },
    {
      name: 'AddLinkHspSurvey',
      path: 'add',
      component: Link
    }
  ]
}

const adminReportFilesRoute = {
  path: '/admin/ReportFiles',
  component: HspDefaultLayout,
  meta: { role: ['administrator','analyst'] },
  children: [
    {
      name: 'ReportFiles',
      path: '/',
      component: ReportFilesAdmin
    }
  ]
}

const adminInstanceLinksRoute = {
  path: '/admin/links/administrative/:surveyId/:surveyUrlId',
  component: HspLinksAdminLayout,
  meta: { role: ['administrator','analyst'] },
  redirect: { name: 'InstanceLinks' },
  children: [
    {
      name: 'InstanceLinks',
      path: '/admin/links/administrative/:surveyId/:surveyUrlId',
      component: LinksAdmin
    },
    {
      name: 'AddLinkInstance',
      path: 'add',
      component: Link
    }
  ]
}

const adminInstancesRoute = {
  path: '/admin/surveys/:surveyId',
  component: HspDefaultLayout,
  meta: { role: allRoles },
  redirect: { name: 'Instances' },
  children: [
    {
      name: 'Instances',
      path: '/admin/surveys/:surveyId/instances',
      component: Instances
    }
  ]
}

const adminInstanceRoute = {
  path: '/admin/surveys/:surveyId/instances/:urlId',
  component: HspInstanceLayout,
  meta: { role: allRoles },
  redirect: { name: 'Instance' },
  children: [
    {
      name: 'Instance',
      path: '/',
      component: Instance,
      redirect: { name: 'InstanceSummary' },
      children: [
        {
          name: 'InstanceSummary',
          path: 'summary',
          component: InstanceSummary
        },
        {
          name: 'InstanceAccess',
          path: 'access',
          component: InstanceAccess
        },
        {
          name: 'InstanceReports',
          path: 'data',
          component: InstanceReports
        },
        {
          name: 'InstanceDashboard',
          path: 'dashboard',
          component: InstanceDashboard
        },
        {
          name: 'InstanceReportFiles',
          path: 'Reports',
          component: InstanceReportFiles
        },
      ]
    }
  ]
}

const adminLogin = {
  path: '/admin',
  component: AuthLayout,
  redirect: '/admin/login',
  props: {
    showNavbar: false
  },
  children: [
    {
      name: 'AdminLogin',
      path: 'login',
      component: AdminLogin
    },
    {
      name: 'ForgotPassword',
      path: 'forgot',
      component: ForgotPassword
    },
    {
      name: 'ResetPassword',
      path: 'reset',
      component: ResetPassword,
      beforeEnter: (to, from, next) => {
        if(to.query.token && to.query.email) {
          next();
        }
        else {
          next(false);
        }
      }
    },
    {
      name: 'AddEmail',
      path: 'email',
      component: EmailAdd,
      meta: {
        role: allRoles,
        redirectedRoute: true
      }
    },
    {
      name: 'ChangePassword',
      path: 'password',
      component: ChangePassword,
      meta: {
        role: allRoles,
        redirectedRoute: true
      }
    }
  ]
}

const routes = [
  {
    name: 'Welcome',
    path: '/',
    component: AuthLayout,
    redirect: 'welcome',
    props: {
      showNavbar: false
    },
    children: [
      {
        path: 'welcome',
        component: Info,
        props: {
          type: 'welcome'
        }
      }
    ]
  },
  {
    name: 'Information',
    path: '/',
    component: HspDefaultLayout,
    redirect: 'info',
    props: {
      showNavbar: false
    },
    children: [
      {
        name: 'Info',
        path: 'info',
        component: Info,
        props: true
      }
    ]
  },
  surveysRoute,
  adminLogin,
  adminSurveysRoute,
  adminUserRoute,
  adminRoleRoute,
  adminSurveyUsersRoute,
  adminHspSurveyUsersRoute,
  adminInstanceSurveyUsersRoute,
  adminLinksRoute,
  adminHspSurveyLinksRoute,
  adminReportFilesRoute,
  adminInstanceLinksRoute,
  adminInstancesRoute,
  adminInstanceRoute,
  {
    path: '*',
    redirect: '/welcome'
  }
]

const router = new VueRouter({
  routes: routes,
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  let record = getRecordFromMeta(to, 'role');
  let redirectedRoute = getRecordFromMeta(to, 'redirectedRoute');
  let role;

  if(record === undefined) {
    next();
  }
  else {
    role = record.meta.role;

    isAuthorized(role)
      .then((result) => {
        if(result === true) {
          handleAuthorized(next, to, redirectedRoute);
        }
        else {
          redirectToLogin(next);
        }
      })
      .catch((e) => {
        redirectToLogin(next);
      })
  }
});

const handleAuthorized = (next, route, redirectedRoute) => {
  const isRedirectedRoute = !!redirectedRoute;
  const redirectRoute = store.getters.redirectRoute;

  if(redirectRoute === null && isRedirectedRoute === true) {
    next(false);
    return;
  }
  if(redirectRoute !== null && route.path !== redirectRoute) {
    next({
      path: redirectRoute
    });
    return;
  }

  next();
}

const getRecordFromMeta = (route, property) => {
  return route.matched.find(record => record.meta[property]);
};

const redirectToLogin = next => {
  next({
    path: '/admin/login'
  });
};

export default router;
